
import { Utils } from "../../utils";
import { BaseService } from "../BaseService";

export class ConsusBaseService extends BaseService {

    protected static instance: ConsusBaseService;

    constructor() {
        super(process.env.REACT_APP_CONSUS_BASE_API_URL ?? "http://127.0.0.1:9305");
    }

    static getInstance() {
        if (!ConsusBaseService.instance) ConsusBaseService.instance = new ConsusBaseService();
        return ConsusBaseService.instance;
    }

    async uploadFile(supportRequestId: string, file: File): Promise<any> {
        return this.report(this.transport.post(`/consus/api/v1/storage/upload/json`, {
            encoding: "BASE64",
            mime_type: file.type,
            content: await Utils.fileToBase64(file),
            name: `${supportRequestId}-${file.name}`,
            folder: "hera/support/comment/attachment",
        }));
    }

    async deleteUploadedFiles(relativePaths: string[]): Promise<any> {
        return this.report(this.transport.delete(`/consus/api/v1/storage/multiple`, {
            data: relativePaths,
        }));
    }

}

